import { COBStep, getCommonReachableSteps } from '../ClientOnboarding.common.utils';
export function getVendorGradientStyle(branding) {
    return {
        background: "linear-gradient(315deg, var(--bg-gradient-color-2, ".concat(branding.backgroundGradientEnd, ") 0%, var(--bg-gradient-color-1, ").concat(branding.backgroundGradientStart, ") 100%)")
    };
}
export function getReachableInnerSteps(relationship) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return [
        COBStep.introduction,
        ...getCommonReachableSteps(relationship, options),
        COBStep.signAndApprove,
        COBStep.allSet
    ];
}
export function getNextStepButtonText(step, relationship) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const reachableSteps = getReachableInnerSteps(relationship, options);
    const currentStepIndex = reachableSteps.indexOf(step);
    if (currentStepIndex === -1) {
        return 'Next';
    }
    if (step === COBStep.signAndApprove) {
        return 'Approve agreement';
    }
    const nextStep = reachableSteps[currentStepIndex + 1];
    if (!nextStep) {
        return 'Approve agreement';
    }
    if (nextStep === COBStep.selectAPackage) {
        return 'Select a package';
    }
    return 'Next';
}
